import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { BrijjSportsStateService } from '@core/state/brijjsports-state.service';

@Component({
  selector: 'app-baseball-spectator',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  templateUrl: './baseball-spectator.component.html',
  styleUrl: './baseball-spectator.component.scss'
})
export class BaseballSpectatorComponent {
  private readonly state = inject(BrijjSportsStateService);

  readonly games = this.state.baseballGames;
}
